// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24px\" viewBox=\"0 -960 960 960\" width=\"24px\" fill=\"#e8eaed\"><path d=\"m600-200-57-56 184-184H80v-80h647L544-704l56-56 280 280-280 280Z\"/></svg>";
// Exports
module.exports = code;